import apiCall from '@/repository'

class SpaceService {
    baseUrl = '/v1/spaces';

    getSpaces = (filters = {}, page = 1, pagelen = 20) => {
        const offset = (page === 1) ? 0 : pagelen * (page - 1);
        const params = {
            pagelen,
            offset,
            ...filters
        };

        return apiCall.get(`${this.baseUrl}`, { params });
    }

    getSpaceById = (id) => {
        return apiCall.get(`${this.baseUrl}/${id}`);
    }

    createSpace = (space) => {
        return apiCall.post(`${this.baseUrl}`, space);
    }

    updateSpace = (uuid, space) => {
        return apiCall.patch(`${this.baseUrl}/${uuid}`, space);
    }

    changeSpaceStatus = (uuid, status, note = null) => {
        return apiCall.patch(`${this.baseUrl}/${uuid}/status`, {
            status,
            note
        });
    }

    deleteSpace = (uuid) => {
        return apiCall.delete(`${this.baseUrl}/${uuid}`);
    }

    createSpaceProduct = (uuid, product) => {
        return apiCall.post(`${this.baseUrl}/${uuid}/products`, product);
    }

    editSpaceProduct = (uuid, productUuid, product) => {
        return apiCall.patch(`${this.baseUrl}/${uuid}/products/${productUuid}`, product);
    }
}

export default new SpaceService();



// WEBPACK FOOTER //
// ./src/services/space.js